<template>
    <div id="tag-dialog">
        <slot name="button">
            <div class="tag-dialog-container">
                <span
                    class="tag-dialog-element"
                    :style="{
                        borderColor: `${tag.color} !important`,
                    }"
                    v-tippy="{
                        followCursor: true,
                        placement: 'bottom-end',
                    }"
                    :content="tag.description"
                    :key="tag._id"
                    v-for="tag of activeTags"
                >
                    <div class="circle" :style="{ backgroundColor: tag.color }"></div>
                    <div>
                        {{ tag.name.slice(0, 15) + (tag.name.length >= 15 ? "..." : "") }}
                    </div>
                </span>
                <a-button
                    v-if="!hideAdd"
                    icon="plus"
                    size="small"
                    type="primary"
                    class="classic-button"
                    style="margin-left: 2px; margin-top: 1px"
                    @click="openPopover = true"
                />
            </div>
        </slot>
        <a-popover v-model="openPopover" trigger="click" placement="bottom">
            <div slot="content">
                <div id="tag-container">
                    <b-input class="mb-3" :placeholder="$t('message.search')" v-model="search" />
                    <h6>{{ $t("message.labels") }}</h6>
                    <div v-for="tag in filteredTags" class="tag">
                        <b-check type="checkbox" v-model="checked[tag._id]" />
                        <div class="tag-lbl" :style="{ backgroundColor: tag.color, color: getTextColor(tag.color) }">
                            {{ tag.name }}
                        </div>
                    </div>
                </div>
            </div>
        </a-popover>
    </div>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapState } from "vuex";

export default {
    name: "TagDialog",
    props: ["value", "hideAdd"],
    data() {
        const checked = (this.value || []).reduce((acc, x) => {
            acc[x] = true;
            return acc;
        }, {});
        return {
            filteredTags: [],
            checked,
            search: "",
            openPopover: false,
        };
    },
    computed: {
        activeTags() {
            const ids = Object.keys(this.checked).filter((id) => this.checked[id]);
            return this.tags.filter((t) => ids.includes(t._id));
        },
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
        }),
        ...mapState({
            tags: (state) => state.tag.tags.data,
        }),
    },
    methods: {
        getTextColor(hex) {
            const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

            const result2 = `rgb(
                 ${parseInt(result[1], 16)},
                 ${parseInt(result[2], 16)},
                 ${parseInt(result[3], 16)})`;

            if (this.getLightnessOfRGB(result2) > 0.5) {
                return "#000000";
            } else {
                return "#ffffff";
            }
        },

        getLightnessOfRGB(rgbString) {
            // First convert to an array of integers by removing the whitespace, taking the 3rd char to the 2nd last then splitting by ','
            const rgbIntArray = rgbString
                .replace(/ /g, "")
                .slice(4, -1)
                .split(",")
                .map((e) => parseInt(e));

            // Get the highest and lowest out of red green and blue
            const highest = Math.max(...rgbIntArray);
            const lowest = Math.min(...rgbIntArray);

            // Return the average divided by 255
            return (highest + lowest) / 2 / 255;
        },

        handleSearch() {
            let q = this.search;
            q = q.split("");
            q = q.join(".*");
            this.filteredTags = this.tags.filter((x) => new RegExp(q, "gi").test(x.name));
        },
    },
    mounted() {
        this.filteredTags = this.tags;
    },
    watch: {
        checked: {
            deep: true,
            handler() {
                this.$emit(
                    "input",
                    Object.keys(this.checked).filter((id) => this.checked[id])
                );
            },
        },
        search: _.debounce(function () {
            this.handleSearch();
        }, 300),
        value: {
            deep: true,
            handler(val) {
                val = (val || []).reduce((acc, x) => {
                    acc[x] = true;
                    return acc;
                }, {});
                if (!_.isEqual(val, this.checked)) {
                    this.checked = val;
                }
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.classic-button {
    border: none;
    background-color: #ffa80040 !important;
    color: #ffa800 !important;
    font-family: Poppins;
    font-weight: 600 !important;
    font-size: 14px;
    cursor: pointer;
    padding: 3px 10px;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
<style lang="scss">
#tag-dialog {
}

.tag-span {
    padding: 2px 6px;
    border-radius: 3px;
    margin-right: 6px;
    user-select: none;
}

#tag-container {
    .tag {
        min-width: 150px;
        display: flex;
        margin-bottom: 4px;
        align-items: center;

        .custom-control.custom-checkbox {
            transform: scale(1.7);

            .custom-control-label {
                &:before {
                    border-radius: 2px;
                }
            }
        }

        &:last-child {
            margin-bottom: 0;
        }
    }

    .tag-lbl {
        user-select: none;
        flex: 1;
        border-radius: 3px;
        margin-left: 4px;
        padding: 4px;
    }
}

.tag-dialog-container {
    display: flex;
    flex-wrap: wrap;

    .tag-dialog-element {
        border-radius: 10px;
        border-style: solid;
        color: black;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 1px;
        padding: 0px 4px;

        .circle {
            width: 10px;
            height: 10px;
            margin-right: 5px;
            border-radius: 100%;
        }
    }
}
</style>
